<div class="container {{ color === 'secondary' ? 'with-bg' : '' }}">
  @if (icon === 'inbox') {
    <img src="assets/icons/empty.svg" alt="No content" />
  }
  @if (icon !== 'inbox') {
    <i class="material-icons icon">{{ icon }}</i>
  }
  <h1>{{ title || 'components.emptyList.title' | translate }}</h1>
  <p>{{ info || 'components.emptyList.info' | translate }}</p>
</div>
